import React from 'react';
import cx from 'classnames';
import { pluralize } from 'utilities/pluralize';

import ExpansionPanel, { ExpansionPanelGroup } from '@magoosh/gre/adaptive_prep_v2/lib/expansion_panel';
import CheckmarkIcon from '@magoosh/gre/adaptive_prep_v2/assets/icons/checkmark_icon.svg';
import InfoIcon from '@magoosh/gre/adaptive_prep_v2/assets/icons/info_icon.svg';
import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  hours: number;
  onSelectHoursOption: (hours: number) => void;
}

const HoursPerDayPanel: React.FC<Props> = ({ hours, onSelectHoursOption }) => {
  const options = [1, 2, 3, 4, 5, 6];

  return (
    <ExpansionPanelGroup>
      <ExpansionPanel
        text={`${pluralize(hours, 'Hour')} per Day`}
        title={
          <span>
            <h4>
              <strong>Customize Your View</strong>
            </h4>
            <p>Select the number of hours you want to see in your plan each day.</p>
          </span>
        }>
        {(onClose) => (
          <>
            <div className="d-flex border-radius u-margin-V-s u-padding-A-s" style={{ backgroundColor: colors.alertInfoBg, color: colors.grayDarker }}>
              <div className="u-margin-R-s">
                <img style={{ minWidth: 30 }} src={InfoIcon} alt="Black circle with the letter i" />
              </div>

              <div>
                Changes will reset all study days - including today.
              </div>
            </div>

            {
              options.map((hoursOption) => {
                if (hoursOption === hours) {
                  return (
                    <div
                      className="d-flex align-items-center justify-content-between u-padding-H-s u-padding-V-xs u-border-B-s"
                      key={hoursOption}
                    >
                      <h4 className="u-margin-A-n">
                        <strong>{pluralize(hoursOption, 'Hour')} per Day</strong>
                      </h4>

                      <div>
                        <img src={CheckmarkIcon} alt="Black circle with a checkmark" />
                      </div>
                    </div>
                  )
                } else {
                  return (
                    <h4
                      className={cx(style.hoursOption, 'u-margin-A-n u-padding-H-s u-padding-V-xs u-border-B-s')}
                      key={hoursOption}
                      onClick={() => onSelectHoursOption(hoursOption)}
                    >
                      {pluralize(hoursOption, 'Hour')} per Day
                    </h4>
                  );
                }
              })
            }
          </>
        )}
      </ExpansionPanel>
    </ExpansionPanelGroup>
  );
}

export default HoursPerDayPanel;
